/**
 * "5 minutes ago" in the reader's language, via Intl.RelativeTimeFormat, so
 * every supported language gets natural wording (ja: "5 分前", he: "לפני 5 דקות")
 * without per-language strings. `numeric: 'auto'` gives "yesterday" / "昨日".
 */
import { LOCALE_MAP } from './types';
const MINUTE = 60_000;
function formatter(language) {
    try {
        return new Intl.RelativeTimeFormat(LOCALE_MAP[language] ?? language, { numeric: 'auto' });
    }
    catch {
        return new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
    }
}
export function formatTimeAgo(when, language, now = Date.now()) {
    const ts = when instanceof Date ? when.getTime() : typeof when === 'string' ? Date.parse(when) : when;
    if (!Number.isFinite(ts))
        return '';
    const rtf = formatter(language);
    // Clock skew can put a fresh timestamp slightly in the future: treat it as now.
    const mins = Math.max(0, Math.floor((now - ts) / MINUTE));
    if (mins < 1)
        return rtf.format(0, 'minute');
    if (mins < 60)
        return rtf.format(-mins, 'minute');
    const hours = Math.floor(mins / 60);
    if (hours < 24)
        return rtf.format(-hours, 'hour');
    const days = Math.floor(hours / 24);
    if (days < 30)
        return rtf.format(-days, 'day');
    return rtf.format(-Math.floor(days / 30), 'month');
}
//# sourceMappingURL=time-ago.js.map